import React from 'react'
import { paths } from '@mc/paths'
import Link from 'components/Link'

interface OutcomeLinkProps {
  className?: string
  outcomeSlug: string
  children: React.ReactNode
  onClick?: (href: string) => void
}

export const OutcomeLink = ({
  className = '',
  outcomeSlug,
  children,
  onClick,
}: OutcomeLinkProps) => {
  const href = paths.outcomePage(outcomeSlug)

  return (
    <Link className={className} onClick={() => onClick?.(href)} href={href}>
      {children}
    </Link>
  )
}
